import { PriceHistory } from '@api';
import { percentChangeFromReference } from '@helpers';
import { LineData } from '@terminal/modules/market-reaction-charts/types';

type PricePoint = { time: string; value?: number };

export type BuildSingleEtfLineArgs = {
  priceData: PricePoint[];
  prevCloseData?: PriceHistory[number];
  lastProportionChange?: number;
  lastKnownPrice?: number;
  lastKnownDate?: string;
  asPercentChange?: boolean;
};

export const buildSingleEtfLine = ({
  priceData,
  prevCloseData,
  lastProportionChange,
  lastKnownPrice,
  lastKnownDate,
  asPercentChange,
}: BuildSingleEtfLineArgs): LineData => {
  const data = asPercentChange
    ? priceData.map(point => ({
        time: point.time,
        value: percentChangeFromReference(point.value, prevCloseData?.close),
      }))
    : priceData;

  return {
    data,
    prevCloseData,
    lastProportionChange,
    lastKnownPrice,
    lastKnownDate,
  };
};
